import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type AdviserClientsAddAccountClickedProps = EventProps

/**
 * @event adviser_clients_add_account_clicked
 * @description Emitted when the "Add Client" button is clicked from the adviser clients page.
 */
export const AdviserClientsAddAccountClickedAnalytics = createAnalyticsStatic<AdviserClientsAddAccountClickedProps>(
    ANALYTICS_EVENTS.ADVISER_CLIENTS_ADD_ACCOUNT_CLICKED,
)

export default AdviserClientsAddAccountClickedAnalytics
